<template>
  <article>
    <header class="header-card">
      <div class="header-item">
        <div class="item-date" v-if="cardObj && cardObj.acptDatetime">
          申込日：<span>{{ cardObj.acptDatetime }}</span>
        </div>
        <div class="item-phone" v-if="cardObj && cardObj.acptNo">
          受付番号：<span>{{ cardObj.acptNo }}</span>
        </div>
      </div>
      <div class="right-item">
        <a-button
          v-if="cardObj && !cardObj.srvicDiv !== 'A10' && isShowBtnPublicStay"
          class="c-btn btn-white btn-sm"
          @click="getPublicStayGuide"
        >
          <span>ご利用案内書を印刷</span>
        </a-button>
        <div class="button-status" v-if="reserveSts === '3'">
          <Button text="手配状況：キャンセル済み" size="small" class="status" />
        </div>
        <div class="button-status" v-else>
          <Button text="手配状況：成立 手配完了" size="small" class="status" />
          <Button
            v-if="statusOrder"
            :text="statusOrder"
            size="small"
            class="status right"
          />
        </div>
      </div>
    </header>
    <div class="menu flex gap-x-4">
      <div class="left-main">
        <div class="main-content">
          <div
            class="image"
            v-if="menuThumbnail"
            :style="menuThumbnail ? { 'background-image': `url(${menuThumbnail})` } : ''"
          ></div>
          <div class="image-1" v-if="!menuThumbnail"></div>
          <div class="content">
            <div class="content-title">
              <!-- <a-tooltip>
                <template slot="title">
                  {{catNm}}
                </template> -->
              <div class="label label-grey-200 catNm" v-if="catNm">{{ catNm }}</div>
              <!-- </a-tooltip> -->
              <div class="flex" v-if="cardObj && cardObj.menuNo">
                [メニューNo.<span>{{ cardObj.menuNo }}</span
                >]
              </div>
            </div>
            <h2 v-if="menuNm" class="two-lines-ellipsis">{{ menuNm }}</h2>
            <div v-if="cardObj && cardObj.billAmtTotal">
              合計：<span>{{ cardObj.billAmtTotal | formatCurrency }}</span>
            </div>
            <div v-if="cardObj && cardObj.billAmtTotal === 0">合計：<span>0円</span></div>
            <div v-if="cardObj && cardObj.pointGrntNumAmt">
              付与ベネポ：<span>{{
                cardObj.pointGrntNumAmt | formatCurrency('ポイント')
              }}</span>
            </div>
            <div v-if="cardObj && cardObj.pointGrntNumAmt === 0">
              付与ベネポ：<span>0ポイント</span>
            </div>
            <!-- <Rating :rate="rating.stars" /> -->
            <div class="address two-lines-ellipsis" v-if="getAreaName">
              <a class="text-black"
                ><i v-if="longitude && latitude" class="icon icon-bor-pin"
              /></a>
              <p class="" v-if="getAreaName">{{ getAreaName }}</p>
            </div>
          </div>
        </div>
        <FooterMenu :is_hidden="!is_hidden" />
      </div>
      <a-divider class="h-vertical hiden-vertical" type="vertical" />
      <div class="right-main">
        <Button style="height: 56px" type="dark" size="large" class="button-apply"
          >もう一度申し込む</Button
        >
        <div class="apply" v-show="!isPublicStay">
          <Button
            type="link"
            :class="!showButton ? 'pointer-events-none cursor-not-allowed' : ''"
            class="apply-item"
            @click="gotoPath(0)"
          >
            <a :class="!showButton ? 'color-gray' : ''" class="text-black"
              >お申し込みをキャンセルする</a
            >
            <i
              :class="!showButton ? 'color-gray' : ''"
              class="icon icon-bor-arrow-right text-black"
            />
          </Button>
        </div>
        <FooterMenu :is_hidden="is_hidden" :menuNo="menuNo" />
      </div>
    </div>
    <a-divider type="horizontal" />
    <article />
    <footer class="mt-6">
      <div class="menu-footer">
        <div class="info-menu">
          <a class="text-black" @click="goLine(1)">お申し込み情報</a>
          <i class="icon icon-bor-arrow-down" />
        </div>
        <div class="info-menu">
          <a class="text-black" @click="goLine(2)">お支払い情報</a>
          <i class="icon icon-bor-arrow-down" />
        </div>
        <div @click="goLine(3)" class="info-menu">
          <a class="text-black">キャンセル規定</a>
          <i class="icon icon-bor-arrow-down" />
        </div>
      </div>
    </footer>
  </article>
</template>

<script>
import _ from 'lodash'
import { Button } from '@/components/primitive'
import FooterMenu from './footerMenu'
import { GET_MENU_BASIC_INFO } from '@/store/modules/menu/actions'
import moment from 'moment'
import downLoadMixin from '@/mixins/download.js'

export default {
  components: {
    Button,
    // Rating,
    FooterMenu
  },
  props: ['cardObj', 'isShowBtnPublicStay'],
  data() {
    return {
      is_hidden: false,
      windowHeight: 0,
      orderDetail: null,
      menuDetail: null,
      menuBasicInfor: null,
      menuThumbnail: null,
      menuNo: null,
      catInfo: null,
      menuIcon: null,
      catLrgClassNm: null,
      catMidClassNm: null,
      catSmlClassNm: null,
      catNm: null,
      latitude: null,
      longitude: null,
      checkInDate: null,
      checkOutDate: null,
      statusOrder: null,
      reserveSts: null,
      showButton: true,
      cancelCloseUpDay: null,
      cancelCloseUpTime: null,
      webCancelAvailDiv: null,
      rating: {
        stars: 4.5
      },
      dateText: '申込日：',
      date: '0000/00/00',
      receptionNum: '受付番号：',
      phoneNumberRecept: '0000000000000',
      buttonStatus: '手配状況：成立 手配完了',
      status: '利用前',
      menuCard: {
        imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
        titleTag: 'カテゴリアイコン',
        menuNum: '[メニューNo.000000]',
        menuName: 'メニュー名メニュー名メニュー名メニュー名メニュー名メニュー名メニュー',
        total: '合計：0,000円',
        benepoGranted: '付与ベネポ：000ポイント',
        address: '東京都23区 > 品川・浜松町・お台場'
      },
      applyOptions: [
        // { text: 'お申し込みを変更する' }
        { text: 'お申し込みをキャンセルする' }
        // { text: '領収書を発行する' }
      ]
    }
  },
  mounted() {
    // const query = this.$route.query
    // console.log('querry', query.isPublicStay)
    // if(query.isPublicStay) {
    //   console.log('11111111111111')
    //   this.isPublicStay = true
    // } else {
    //   console.log('222222222')
    //   this.isPublicStay = false
    // }
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerWidth
    })
  },
  watch: {
    cardObj: {
      deep: true,
      handler(val) {
        this.cardObj = val
        this.getMenuDetail()
      }
    },
    windowHeight() {
      if (this.windowHeight > 768) {
        this.is_hidden = true
      } else {
        this.is_hidden = false
      }
    }
  },
  computed: {
    isPublicStay() {
      const { isPublicStay } = this.$route.query
      return isPublicStay === 'true'
    },
    getAreaName() {
      if (this.menuDetail && this.menuDetail.areaInfomation) {
        const areaMidClassNm = _.get(
          this.menuDetail,
          'areaInfomation.areaMidClassNm',
          null
        )
        const areaDtlClassNm = _.get(
          this.menuDetail,
          'areaInfomation.areaDtlClassNm',
          null
        )

        if (areaMidClassNm && areaDtlClassNm) {
          return `${areaMidClassNm} > ${areaDtlClassNm}`
        }
        if (areaMidClassNm && !areaDtlClassNm) {
          return `${areaMidClassNm}`
        }
        if (!areaMidClassNm && areaDtlClassNm) {
          return `${areaDtlClassNm}`
        }
      }
      return ''
    }
  },
  methods: {
    async getPublicStayGuide() {
      const acptNo = this.cardObj.acptNo
      const data = {
        // staffNm: 'string'
      }
      this.$repositories('order')
        .getPublicStayGuide(acptNo, data)
        .then(
          (response) => {
            const pdfFilePath = _.get(response, 'pdfFilePath', '')
            downLoadMixin.$_downloadPdfUrlMixin(pdfFilePath)
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
    },
    getMenuDetail() {
      console.log(this.cardObj)
      if (this.cardObj) {
        const checkInTm = _.get(this.cardObj, 'checkInDate', null)
        const checkOutTm = _.get(this.cardObj, 'checkOutDate', null)
        if (checkInTm && checkOutTm) {
          this.checkInDate = moment(checkInTm).format('YYYY/MM/DD')
          this.checkOutDate = moment(checkOutTm).format('YYYY/MM/DD')
        }
        this.reserveSts = _.get(this.cardObj, 'reserveSts', '')
        this.cancelCloseUpDay = _.get(this.cardObj, 'cancelCloseUpDay', null)
        this.cancelCloseUpTime = _.get(this.cardObj, 'cancelCloseUpTime', null)
        this.webCancelAvailDiv = _.get(this.cardObj, 'webCancelAvailDiv', null)
        this.getStatusOrder(this.checkInDate, this.checkOutDate)
        const { menuNo } = {
          menuNo: this.cardObj.menuNo
        }
        this.$store.dispatch(GET_MENU_BASIC_INFO, { menuNo }).then(
          (data) => {
            this.menuDetail = data
            this.menuThumbnail = _.get(data, 'menuImages[0].imageUrl', '')
            this.menuIcon = _.get(data, 'menuIcons[0]')
            this.menuNm = _.get(data, 'menuNm', '')
            this.menuNo = _.get(data, 'menuNo', '')
            this.getCatNm(_.get(data, 'categoryInfomation', ''))
            this.longitude = _.get(data, 'areaInfomation.longitude', '')
            this.latitude = _.get(data, 'areaInfomation.latitude', '')
          },
          (error) => {
            console.log('error ', error)
          }
        )
      }
    },
    getStatusOrder(checkInDate, checkOutDate) {
      const today = moment().format('YYYY/MM/DD')
      if (today < checkInDate) {
        this.statusOrder = '利用前'
      }
      if (today > checkOutDate) {
        this.statusOrder = '利用済み'
      }
      if (today >= checkInDate && today <= checkOutDate) {
        this.statusOrder = '利用中'
      }
      this.showButtonCancel()
    },
    showButtonCancel() {
      const today = moment()
      let timeFeature = null
      let hourTm = null
      let minuteTm = null
      if (this.cancelCloseUpTime) {
        hourTm = this.cancelCloseUpTime.substring(0, 2)
        minuteTm = this.cancelCloseUpTime.substring(2, 4)
      }
      if (this.cancelCloseUpDay >= 0) {
        timeFeature = moment().add(this.cancelCloseUpDay, 'days')
        timeFeature.set({
          hour: hourTm,
          minute: minuteTm
        })
      }
      if (today > timeFeature) {
        this.showButton = false
      } else {
        this.showButton = true
      }
      if (this.reserveSts === '3' || (!this.checkInDate && !this.checkOutDate)) {
        this.showButton = false
      } else if (today > moment(this.checkOutDate)) {
        this.showButton = false
      } else if (
        today >= moment(this.checkInDate) &&
        today <= moment(this.checkOutDate)
      ) {
        this.showButton = false
      }
    },
    shareUrl() {
      return `${location.protocol}//${location.host}/bs-02-001?menuNo=${this.menuNo}`
    },
    goLine(index) {
      this.$emit('gotoMap', index)
    },
    gotoPath(index) {
      const query = this.$route.query
      switch (index) {
      case 1:
        this.$router.push({ path: '/', query })
        return
      case 0:
        this.$router.push({ path: '/mypage/cancel-confirmation-information', query })
        return
      case 3:
        this.$router.push({ path: '/register-rooms', query })
      }
    },
    gotoMap(longitude, latitude) {
      window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
    },
    getCatNm(catInfo) {
      this.catLrgClassNm = _.get(catInfo, 'catLrgClassNm', null)
      this.catMidClassNm = _.get(catInfo, 'catMidClassNm', null)
      this.catSmlClassNm = _.get(catInfo, 'catSmlClassNm', null)

      if (!this.catLrgClassNm && !this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catSmlClassNm}`
      }
      if (!this.catLrgClassNm && this.catMidClassNm && !this.catSmlClassNm) {
        this.catNm = `${this.catMidClassNm}`
      }
      if (this.catLrgClassNm && !this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm}`
      }
      if (!this.catLrgClassNm && this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catMidClassNm}・${this.catSmlClassNm}`
      }
      if (this.catLrgClassNm && !this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm}・${this.catSmlClassNm}`
      }
      if (this.catLrgClassNm && this.catMidClassNm && !this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm}・${this.catMidClassNm}`
      }
      if (this.catLrgClassNm && this.catMidClassNm && this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm}・${this.catMidClassNm}・${this.catSmlClassNm}`
      }
      if (this.catLrgClassNm && !this.catMidClassNm && !this.catSmlClassNm) {
        this.catNm = `${this.catLrgClassNm}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
.right-item {
  display: flex;
}
</style>
